import { ArrowDownward } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

export default function CustomIconButton({
  bgColor,
  iconVisible,
  CustomIcon,
  handleOnClick,
  size = "small",
  tooltipText = "",
  classes = "",
  buttonClasses = "",
  disabled = false,
  buttonId = "",
}) {
  return (
    <div className={`flex justify-center ${bgColor} ${classes}`}>
      {!iconVisible ? (
        ""
      ) : (
        <Tooltip title={tooltipText}>
          <span>
            <IconButton
              id={buttonId}
              className={buttonClasses}
              size={size}
              onClick={handleOnClick}
              disabled={disabled}
            >
              {CustomIcon ? CustomIcon : <ArrowDownward />}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </div>
  );
}
